import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useThemeMode } from '../../../../hooks/v0/useThemeMode';

interface FocusNavigationBarProps {
  title: string;
  showBackButton?: boolean;
  backButtonText?: string;
  rightButton?: React.ReactNode;
  largeTitleMode?: boolean;
  onBackClick?: () => void;
}

/**
 * iOS 风格的导航栏
 */
export const FocusNavigationBar: React.FC<FocusNavigationBarProps> = ({
  title,
  showBackButton = false,
  backButtonText,
  rightButton,
  largeTitleMode = false,
  onBackClick,
}) => {
  const navigate = useNavigate();
  const { isDarkMode } = useThemeMode();

  const handleBack = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="font-ios border-b border-ios-gray5/50 dark:border-ios-dark-gray5/50">
      {/* 标准标题栏 */}
      <div className="relative flex items-center justify-between h-11 px-4">
        {showBackButton ? (
          <button
            onClick={handleBack}
            className="flex items-center text-ios-blue dark:text-ios-dark-blue py-2 -ml-2"
          >
            <svg className="w-5 h-5" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {backButtonText && <span className="text-ios-body font-medium">{backButtonText}</span>}
          </button>
        ) : (
          <div className="w-20"></div>
        )}

        {!largeTitleMode && (
          <h1 className="text-ios-headline font-semibold text-center">{title}</h1>
        )}

        {rightButton ? (
          <div className="flex items-center justify-end w-20">
            {rightButton}
          </div>
        ) : (
          <div className="w-20"></div>
        )}
      </div>

      {/* 大标题模式 */}
      {largeTitleMode && (
        <div className="relative px-4 pb-2">
          <h1 className="text-ios-largeTitle font-bold">{title}</h1>
        </div>
      )}
    </div>
  );
};
